




















































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import applicationForm9 from "@/modules/budget/monitoring/input-forms/components/application9/application-form-9.vue";
import DatePicker from 'vue2-datepicker';
import { FilterSettingsForm } from '@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm'
import application12_14 from "@/modules/budget/monitoring/input-forms/components/application12/application12_14.vue";
import Application19 from "@/modules/budget/monitoring/input-forms/components/application19/Application19.vue";
import Application23 from "@/modules/budget/monitoring/input-forms/components/application23/Application23.vue";
import applicationForm26 from "@/modules/budget/monitoring/input-forms/components/application26/application-form-26.vue";
import applicationForm41 from "@/modules/budget/monitoring/input-forms/components/application41/application_41.vue";
import axios from "axios";
import { isParentLocked, parentErrorText } from '@/modules/budget/monitoring/input-forms/common/parentError'
import applicationForm21 from "@/modules/budget/monitoring/input-forms/components/application21/application21.vue";

@Component({
    components: {
        'date-picker': DatePicker,
        'application-form-9': applicationForm9,
        'application-form1214': application12_14,
        'application-form19': Application19,
        'application-form23': Application23,
        'application-form-26': applicationForm26,
        'application-form-21': applicationForm21,
        'application-form-41': applicationForm41
    }
})
export default class BEIFOpenWindow extends Vue {
    $refs!: {
        refApp9: HTMLFormElement,
        refApp1214: HTMLFormElement,
        refApp19: HTMLFormElement,
        refApp23: HTMLFormElement,
        refApp41: HTMLFormElement
    }
    @Prop({
        required: true,
        default: null
    })
    private currForm!:any;
    @Prop({
        required: true,
        default: null
    })
    private filterSettingsForm!:FilterSettingsForm;
    @Prop({
        required: true,
        default: () => []
    })
    private statusList!: any[];


    private date_420: Date = new Date(this.currForm.year, this.currForm.month, 15);

    public get isSaveButtonDisabled(): boolean {
        return !this.haveEditAccess
            || ['app17', 'app13cons'].includes(this.currForm.form_code)
    }
    private get haveEditAccess() {
        return this.filterSettingsForm.edit_access
            && ![31, 26].includes(this.currForm.status.status)
            && (this.currForm.region.slice(4, 6) !== '00' || this.currForm.form_code === 'app19')
            && (
                !this.currForm.parent
                || (![31, 26].includes(this.currForm.parent?.status?.status)
            ))
    }
    // пояснение к неактивным действиям: только когда форма заблокирована родителем в статусе 26/31
    private get parentLockTitle(): string | null {
        return isParentLocked(this.currForm?.parent) ? parentErrorText(this, this.currForm.parent) : null
    }
    private get haveDeleteAccess() {
        return this.haveEditAccess
    }
    private get inputForm() {
        if (!this.currForm) {
            return null
        }
        if (['app8', 'app9', 'app8_ex', 'app9_ex'].includes(this.currForm.form_code)) {
            return 'app9'
        } else if (['app12', 'app12cons', 'app14_rb', 'app14cons_rb', 'app14_ob', 'app14cons_ob', 'app18'].includes(this.currForm.form_code)) {
            return 'app12_14'
        } else if (['app19', 'app13cons', 'app13_ob', 'app17', 'app13_rn', 'app15'].includes(this.currForm.form_code)) {
            return 'app19'
        } else if (['app21'].includes(this.currForm.form_code)) {
            return 'app21'
        } else if (this.currForm.form_code === 'app23') {
            return 'app23'
        } else if (['app26'].includes(this.currForm.form_code)) {
            return 'app26'
        } else if (['app41'].includes(this.currForm.form_code)) {
            return 'app41'
        }
    }
    private async created () {
        this.date_420.setDate(15)
        await this.loadReasons()
    }
    private mounted() {
    }
    private async saveForm() {
        if (this.facade) {
            await this.facade.saveData()
        }
    }
    private showActionsTab = true;
    private formatedDate(date_to: Date) {
        return `${date_to.getFullYear()}-${date_to.getMonth() + 1}-${date_to.getDate()}`
    }
    private reasonsFull: any[] = []
    private dictReasons:any = {};
    private reasonsReady: boolean = false;
    private get repdate(): Date {
        const month = this.currForm.month
        const year = this.currForm.year
        if (['app8', 'app9', 'app8_ex', 'app9_ex'].includes(this.currForm.form_code)) {
            if (['app8', 'app9'].includes(this.currForm.form_code)) {
                return new Date(year, month, 0)
            } else {
                return new Date(year, month, 1)
            }
        } else if (['app12', 'app12cons', 'app14_rb', 'app14cons_rb', 'app14_ob', 'app14cons_ob', 'app18'].includes(this.currForm.form_code)) {
            return new Date(year, month, 1)
        }
        return new Date(year, month, 0)
    }
    private async loadReasons() {
        await axios.get(`/api-py/input-forms/application-reasons/${this.formatedDate(this.repdate)}`).then(resp => {
            if (resp.status === 200) {
                const dictsList:any = resp.data[0];
                const grDicts:any = resp.data[1];
                for (const d of dictsList) {
                    let grob:any = grDicts[d.gr_ob_id]
                    if (!grob) {
                        grob = {
                            name_ru: '',
                            name_kk: '',
                            name_en: ''
                        }
                    }
                    d.gr_ob_name_ru = grob.name_ru
                    d.gr_ob_name_kk = grob.name_kk
                    d.gr_ob_name_en = grob.name_en
                    let grpl:any = grDicts[d.gr_pl_id]
                    if (!grpl) {
                        grpl = {
                            name_ru: '',
                            name_kk: '',
                            name_en: ''
                        }
                    }
                    d.gr_pl_name_ru = grpl.name_ru
                    d.gr_pl_name_kk = grpl.name_kk
                    d.gr_pl_name_en = grpl.name_en
                }
                const dict: any = {}
                for (const r of dictsList) {
                    dict[r.id] = r
                }
                this.reasonsFull = dictsList
                this.dictReasons = dict
                this.reasonsReady = true
            }
        }).catch(e => {})
        if (!this.reasonsReady) {
            this.makeToast(
                'danger',
                this.$t('modules.common.error'),
                this.$t('modules.budget_execution_monitoring.reports.app_9.reasons_load_error')
            )
        }
    }

    private facade: any = null
    private get downloadList() {
        return this.facade?.downloadList ?? []
    }
    private onRegisterFacade(facade:any) {
        this.facade = facade;
    }
    private onPullExistingData() {
        this.facade?.pullExistingData()
    }
    private async onBack() {
        let isReady = true
        if (this.facade) {
            isReady = await this.facade.onBack()
        }
        if (isReady) this.$emit('onBack')
    }
    private onSaveReason() {
        if (this.facade) {
            this.facade.onSaveReason();
        }
    }
    private closeReasonInput() {
        this.showActionsTab = true;
    }
    private openReasonInput(model:number|null = null) {
        if (!this.facade) {
            return
        }

        // Separte logic for app19 forms
        if (['app13_ob', 'app13_rn', 'app15'].includes(this.currForm.form_code)) {
            if (this.facade.reasonEligibleEntries.length === 0) {
                this.makeToast(
                    'warning',
                    this.$t('modules.budget_execution_monitoring.reports.app19.attention'),
                    this.$t('modules.budget_execution_monitoring.reports.app19.no_undeveloped_rows'),
                )
                return
            }
        }

        if (model) {
            this.facade.inputModelType = model
        }
        this.showActionsTab = false
        this.facade.showReasonInput = true;
    }

    private openAddMeasureModal() {
        if (!this.facade) {
            return
        }

        this.facade.openAddMeasureModal()
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

}
